import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { TerminalPageData } from '@/types/dashboard/TeminalPage';

// Modificar cuando tengamos una response de ejemplo

type GetTerminalPageResponse = {
  value: TerminalPageData;
};

type TerminalPageQueryType = {
  armador: string;
};

export const getDashboardTerminalPageData = async (
  query: TerminalPageQueryType
): Promise<TerminalPageData> => {
  try {
    const res = await apiClient.post<GetTerminalPageResponse>(
      Endpoints.DashboardTerminalPage,
      query
    );
    return res.data.value || {};
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
